<template>
  <div class="page">
    <div class="banner">
      <img src="../../assets/images/news/banner.png" />
    </div>

    <article>
      <h2>{{ item.title }}</h2>
      <h3>{{ date2Str(item.create_time, "yyyy/MM/dd hh:mm") }}</h3>

      <div class="content" v-html="item.content"></div>
    </article>
  </div>
</template>

<script>
import { date2Str } from "@/assets/js/utils.js";
import newsList from "./newsList";

export default {
  data() {
    return {
      item: {}
    };
  },
  methods: {
    date2Str,
    // 文本编辑器：http://www.wangeditor.com/
    getContent() {}
  },

  mounted() {
    const id = parseInt(this.$route.params.news_id);
    this.item = newsList.find(m => m.id === id);
  }
};
</script>

<style lang="scss" scoped>
.banner img {
  width: 100%;
}

.page {
  display: flex;
  flex-direction: column;
  align-items: center;

  article {
    width: 80vw;
    // padding-left: 20%;
    // padding-right: 20%;

    > h2 {
      padding-top: 30px;
      padding-bottom: 10px;
      text-align: center;
      // font-size: 28px;
      color: #333333;
    }
    > h3 {
      padding-bottom: 30px;
      text-align: center;
      // font-size: 18px;
      font-weight: 500;
      color: #999999;
    }
    > .content {
      text-align: justify;
      text-align: center;

      ::v-deep p {
        width: 100%;
        padding-bottom: 20px;
        font-size: 0.08rem;
        line-height: 0.18rem;
        text-indent: 0.16rem;
        color: #666666;
        text-align: justify;
      }

      ::v-deep img {
        padding: 20px 0;
        text-indent: 0;
        width: 100%;
      }
    }
  }
}
</style>
